

/**
 * Sorts an array alphabetically by a specified object key using locale-sensitive comparison.
 *
 * @param array - The array to sort. Elements may be objects (with the given key) or values coercible to strings.
 * @param sortValue - The key whose string value will be used for comparison. Missing or undefined values are treated as empty strings.
 * @returns The same array reference sorted in place (mutated) and also returned for convenience.
 *
 * @remarks
 * - Uses String.prototype.localeCompare with sensitivity set to "base" for case- and accent-insensitive ordering.
 * - The function mutates the input array rather than producing a new array.
 * - The comparison uses the runtime's default locale; pass explicitly formatted strings if a specific locale is required.
 *
 * @example
 * const items = [{ name: 'banana' }, { name: 'Apple' }];
 * sortArrayAlphabetically(items, 'name'); // [{ name: 'Apple' }, { name: 'banana' }]
 */
export const sortArrayAlphabetically = (array : any[], sortValue: string) => {
    return array.sort((a,b)=> { 
        return (a[sortValue] ?? "").localeCompare(b[sortValue] ?? "", undefined, {
            sensitivity: 'base',
        })
    })
}